import { TakeEffect, takeLatest } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_PROGRESS_PATH_KEY } from '@/swagger/constants/contents-orchestrator-keys';
import { KEY_POST_CONTENT_PROGRESS, API_POST_CONTENT_PROGRESS } from '../constants';
import { MOCK_RESPONSE_POST_CONTENT_PROGRESS } from '../mocks';

type API_POST_CONTENT_PROGRESS_PROPS = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_PROGRESS_PATH_KEY
>;

export type RequestPostContentProgress = API_POST_CONTENT_PROGRESS_PROPS['request']['path'] &
  API_POST_CONTENT_PROGRESS_PROPS['request']['body'];

export type ResponsePostContentProgress = API_POST_CONTENT_PROGRESS_PROPS['response']['body'];

export type CallParamsPostContentProgress = Omit<RequestPostContentProgress, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePostContentProgress = ResponsePostContentProgress;

type CallErrorPostContentProgress = {
  message: string;
  code: number;
  type: string;
  title: string;
  status: number;
};

type CallSelectorsPostContentProgress = {
  data?: CallResponsePostContentProgress;
};

export const postContentProgressCall = createGeneralCall<
  CallParamsPostContentProgress,
  CallResponsePostContentProgress,
  CallErrorPostContentProgress,
  CallSelectorsPostContentProgress
>({
  id: KEY_POST_CONTENT_PROGRESS,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_POST_CONTENT_PROGRESS(org as unknown as string, payload.contentId);
    },
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  selectors: {
    data: ({ selectors }) => createSelector(selectors.response, res => res || undefined),
  },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_CONTENT_PROGRESS : undefined,
  cancellable: true,
  takeEffect: takeLatest as unknown as TakeEffect,
  rsmOptions: {
    doubleRun: true,
  },
});
